import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
  Box,
  Container,
  Text,
  Badge,
  Image,
  Flex,
  VStack,
  Skeleton,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComputer, faGlobe } from '@fortawesome/free-solid-svg-icons';
import ImageSlider from '../common/ImageSlider';

const Featured = () => {
  const [gameData, setGameData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch game data from the local JSON file
        const response = await fetch('./Games.json');
        const data = await response.json();
        setGameData(data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Render the featured game
  return (
    <Container
      maxW={['90vw', null, null, '1200px']}
      p='0'
      mt='100px'
      gap={['5', null, null, '10']}
      display='flex'
      flexDirection={['column', null, null, 'row']}
      alignItems={['center', null, null, 'normal']}
    >
      <Box>
        {isLoading ? (
          <Skeleton width={['100vw', null, null, '800px']} height='450px' />
        ) : (
          <Box
            width={['90vw', null, null, '800px']}
            height={['200px', '350px', '400px', '450px']}
          >
            {gameData.length > 0 && (
              <Image
                src={gameData[0].thumbnail}
                rounded='md'
                fit='cover'
                w='100%'
                h='100%'
              />
            )}
          </Box>
        )}
      </Box>
      {!isLoading && (
        <Flex
          direction='column'
          gap='4'
          alignItems='flex-start'
          p='4'
          bgColor='charcoal.800'
          rounded='md'
          width='100%'
        >
          <Flex direction='column' gap='2'>
            <Link to={`game/${gameData[0].id}`}>
              <Text fontSize='3xl'>{gameData[0].title}</Text>
            </Link>
            <Flex alignItems='center' gap='2'>
              {gameData[0].platform === 'Windows' ? (
                <FontAwesomeIcon icon={faComputer} />
              ) : gameData[0].platform === 'Web Browser' ? (
                <FontAwesomeIcon icon={faGlobe} />
              ) : (
                <>
                  <FontAwesomeIcon icon={faComputer} />
                  <FontAwesomeIcon icon={faGlobe} />
                </>
              )}
            </Flex>
          </Flex>
          <Text color='whiteAlpha.800' fontSize='xl'>
            Now Available
          </Text>
          <Text color='whiteAlpha.700'>{gameData[0].short_description}</Text>
          <Badge>FREE</Badge>
        </Flex>
      )}
    </Container>
  );
};

export default Featured;
